import axiosClient from "../../../../../../system/helpers/axiosConfig";
import { API_ROUTES } from "../../../../../../system/constants/apiRoutes";

export const postGeoDetails = (params) => {
  return axiosClient
    .post(API_ROUTES.reports.geo_details.path, { ...params })
    .then((r) => r.data);
};
